<template>
    <div>
        <v-row　justify="center" class="mt-16">
            <v-col cols="12" xl="6">
                <p class="text-center font-weight-bold explanatory_text">
                    パスワード再設定のURLをメールで送信しました。
                </p>
                <p class="text-center explanatory_text">
                入力されたメールアドレスがDX-Signに登録されていない場合は<br />
                再設定用のメールは届きません。
                </p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <button-component block href="/documents/login">ログイン画面へ</button-component>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
    .password_reset_link a:hover {
        text-decoration-line: underline;
    }
    .explanatory_text {
        font-size: 18px;
    }
</style>